<template>
  <div
    class="card-shadow d-flex justify-space-between gap-2 pa-3 rounded text-nowrap overflow-y-auto"
  >
    <material-thumbnail :code="material.code" :name="material.name">
      <div class="mt-1">
        <span>Importe:</span>
        <template v-if="material.discount > 0">
          <small class="ml-1 text-decoration-line-through">{{
            formatNumber(material.originalPrice)
          }}</small>
        </template>
        <span class="error--text font-weight-bold">
          {{ formatNumber(material.price) }}
        </span>
      </div>
    </material-thumbnail>
    <div
      class="d-flex flex-column align-end justify-space-between text--darken-2 grey--text"
    >
      <div class="text-right">
        <p class="mb-0 font-weight-bold">
          Existencia {{ formatNumberOptionalDecimals(material.stock, '') }}
        </p>
        <small>Centro {{ material.center }}</small>
      </div>
      <v-menu offset-y left :close-on-content-click="false" min-width="130px">
        <template #activator="{ on, attrs }">
          <v-btn
            class="green-button mt-2 w-auto"
            v-bind="attrs"
            max-width="65px"
            v-on="on"
          >
            <v-icon>mdi-cart</v-icon>
          </v-btn>
        </template>
        <v-card color="white" class="pa-2">
          <v-form
            ref="quantityForm"
            :disabled="addingMaterial"
            @submit.prevent="addMaterial"
          >
            <plus-minus-input
              v-model="quantity"
              :max="material.stock"
              :min="0"
              :flat="false"
              inline
            />
            <v-btn
              class="green-button mt-2"
              small
              dark
              block
              type="submit"
              :disabled="!quantity"
              :loading="addingMaterial"
            >
              Confirmar
            </v-btn>
          </v-form>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
  import MaterialThumbnail from '@/components/materialSnapshot/MaterialThumbnail.vue';
  import PlusMinusInput from '@/components/PlusMinusInput.vue';
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'ClearanceListItem',

    components: { MaterialThumbnail, PlusMinusInput },
    mixins: [numbersFormats],

    props: {
      value: Boolean,
      material: {
        type: Object,
        required: true,
        validator(value) {
          return (
            value &&
            typeof value.code === 'string' &&
            typeof value.name === 'string' &&
            typeof value.stock === 'number'
          );
        },
      },
      onAddMaterialToCart: {
        type: Function,
        required: true,
      },
    },

    data() {
      return {
        quantity: this.material.stock > 0 ? 1 : null,
        addingMaterial: false,
      };
    },

    methods: {
      async addMaterial() {
        if (!this.quantity) return;

        this.addingMaterial = true;
        await this.onAddMaterialToCart({
          sku: this.material.code,
          quantity: this.quantity,
        });
        this.quantity = null;
        this.addingMaterial = false;
      },
    },
  };
</script>
